<mat-card-header>
  <div style="width:90%">
    <mat-card-title>
      <label class="mat-h2 bold">Possível duplicidade encontrada</label>
    </mat-card-title>
  </div>
  <div style="width:10%; cursor:pointer;">
    <mat-icon class="btnCancel" style="position: relative; float: right; margin-right: 5px" (click)="closePopup()">cancel</mat-icon>
  </div>

</mat-card-header>
<mat-card-content style="width: 500px">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="15%">
    <label class="mat-h4 bold">Protocolo: </label>
    <label class="mat-h4">{{data.idProtocolo}}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5%">
    <label class="mat-h4 bold">N° da Nota Fiscal:</label>
    <label class="mat-h4">{{data.notaFiscal}}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="14%">
    <label class="mat-h4 bold">Criado por:</label>
    <label class="mat-h4">{{data.loginUsuarioCriacao}}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="14%">
    <label class="mat-h4 bold">Criado em: </label>
    <label class="mat-h4">{{data.dataHoraCriacaoExibicao}}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="4%">
    <label class="mat-h4 bold">CNPJ Fornecedor:</label>
    <label class="mat-h4">{{data.cnpjfornecedor}} </label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="21%">
    <label class="mat-h4 bold">Serie:</label>
    <label class="mat-h4">{{data.serieNotaFiscal}}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="12%">
    <label class="mat-h4 bold">Vencimento:</label>
    <label class="mat-h4">{{data.dataVencimentoNfExibicao}}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="21%">
    <label class="mat-h4 bold">Valor:</label>
    <label class="mat-h4">{{data.valor | currency:'BRL':true}}</label>
  </div>

</mat-card-content>
<div style="width:90%">
  <div>
    <mat-card-title>
      <label class="mat-h2 bold" style="color:red">Atenção </label>
    </mat-card-title>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="15%" style="margin-bottom: 20px;">
    <label class="bold" style="font-size: 14px;">O protocolo detalhado acima contém parâmetros de entrada semelhantes ao que está sendo criado, deseja continuar?</label>
  </div>
</div>
<mat-action-row class="footer">
  <button id="btnTipoDoc" mat-button color="primary" class="btn-primary" (click)="confirm()">CONFIRMAR</button>
</mat-action-row>